import { AUTH_ERROR, AUTH_LOGOUT, AUTH_REFRESH, AUTH_REQUEST, AUTH_SUCCESS } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import { ApiService } from '../../service/api/ApiService'
import Token from '../../components/helpers/Token'

const state = {
  access_token: localStorage.getItem('access_token') || '',
  refresh_token: localStorage.getItem('refresh_token') || '',
  status: '',
  hasLoadedOnce: false,
  userRole: '',
}

const getters = {
  isAuthenticated: state => !!state.access_token,
  getUserRole: state => {
    if (state.userRole) {
      return state.userRole
    }

    if (localStorage.getItem('access_token')) {
      return Token.payload(localStorage.getItem('access_token')).role
    }

    return 'GUEST_ROLE'
  },
  roles: (state, getters) => roles => roles.includes(getters.getUserRole),
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_REFRESH]: (state) => {
    state.status = 'refresh'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.access_token = resp.access_token
    state.refresh_token = resp.refresh_token
    state.hasLoadedOnce = true
    state.userRole = Token.payload(resp.access_token).role
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.access_token = ''
    state.refresh_token = ''
    state.userRole = 'GUEST_ROLE'
  },
}

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      ApiService.login(user).then(({ data }) => {
        localStorage.setItem('access_token', data.access_token)
        localStorage.setItem('refresh_token', data.refresh_token)

        ApiService.setAccessToken(data.access_token)

        commit(AUTH_SUCCESS, data)
        dispatch(USER_REQUEST)

        resolve(data)
      }).catch(err => {
        console.log(err)
        commit(AUTH_ERROR, err)
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        reject(err)
      })
    })
  },

  [AUTH_REFRESH]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REFRESH)
      const refreshToken = localStorage.getItem('refresh_token')
      ApiService.refreshToken(refreshToken).then(({ data }) => {
        localStorage.setItem('access_token', data.access_token)
        localStorage.setItem('refresh_token', data.refresh_token)

        ApiService.setAccessToken(data.access_token)

        commit(AUTH_SUCCESS, data)
        resolve(data)
      }).catch(err => reject(err))
    })
  },

  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      resolve()
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
